import { EventLogEntry } from './dtos';
import LocalController from './tmcontrollerlocal';
import { Board, Game, StateMachineValue } from './tmmodel';

export enum ControllerType {
  LOCAL = 'local',
  REMOTE = 'remote',
}

export interface Controller {
  receiveMsg: (state: StateMachineValue, params: unknown) => Promise<false | void>;
  sendMsg: (state: StateMachineValue, params: unknown) => Promise<false | void>;
  getGame(): Game;
  getBoard(): Board;
  getEventLog: () => EventLogEntry[];
  getPlayerId: () => number | false;
  getHorseId: () => number | false;
  closeConnection?: () => void;
  getType: () => ControllerType;
}

export interface View {
  receiveMsg: (state: StateMachineValue, params: unknown) => Promise<void>;
  sendMsg: (state: StateMachineValue, params: unknown) => Promise<false | void>;
  controller: LocalController;
  playerid: number;
}
